// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/scss/global.scss
// module id = 65
// module chunks = 0